import { FormattedMessage } from 'react-intl'
import { faCircleInfo } from '@fortawesome/pro-solid-svg-icons'

import { Alert } from 'Components/_theme'
import type { CardDetailsListItem } from 'Components/CardDetailsList/CardDetailsList.types'
import { FormattedCurrency } from 'Components/FormattedCurrency/FormattedCurrency'
import { PageErrorState } from 'Components/PageErrorState/PageErrorState'
import { PresentationCard } from 'Components/PresentationCard/PresentationCard'
import { ScrollToTop } from 'Components/ScrollToTop/ScrollToTop'

import { useStore } from 'Stores/index'

import type { DeviceTypeEnum } from 'Types/deviceTypes'

import { OrderStickyFooter } from '../../OrderStickyFooter/OrderStickyFooter'
import type { RepairUpgradeInfoStepProps } from '../Steps.types'

export const RepairUpgradeInfoStep = (props: RepairUpgradeInfoStepProps) => {
  const { handleNextStep } = props

  const { rentalStore } = useStore()
  const { rentalDetails, isRentalDetailsError } = rentalStore

  if (isRentalDetailsError || !rentalDetails) {
    return <PageErrorState />
  }

  const { rental } = rentalDetails

  const generateListItems: CardDetailsListItem[] = [
    {
      label: 'RentalDetails_copayment',
      value: <FormattedCurrency value={rental.coPaymentAmount} />,
    },
    {
      label: 'RentalDetails_imei',
      value: rental?.stocklistItem?.imei,
    },
    {
      label: 'RentalDetails_imei2',
      value: rental?.stocklistItem?.imei2,
    },
    {
      label: 'RentalDetails_serial',
      value: rental?.stocklistItem?.serialNumber,
    },
  ]

  return (
    <div>
      <ScrollToTop />

      <Alert className="mt-4" iconLeft={faCircleInfo} variant="info">
        <FormattedMessage id="RepairUpgrade_info_text" />
      </Alert>

      {rental?.children?.length ? (
        <Alert className="mt-1 mb-4" iconLeft={faCircleInfo} variant="info">
          <FormattedMessage
            id="Main_rental_action_info_text"
            values={{
              actionLabel: <FormattedMessage id="RepairUpgrade_info_header" />,
            }}
          />
        </Alert>
      ) : null}

      <PresentationCard
        cardClassName="DeviceRentalStep mt-4"
        header={rental.deviceDefinition?.name ?? ''}
        imagePlaceholderType={
          rental.deviceDefinition?.productType as DeviceTypeEnum
        }
        imageSource={rental.deviceDefinition?.imageURL}
        listItems={generateListItems}
      />

      <OrderStickyFooter handleNextAction={handleNextStep} />
    </div>
  )
}
